import React from "react";
import {
  getMetricsDataColWidth,
  METRICS_TABLE_LABEL_COL_WIDTH,
  METRICS_TABLE_MIN_DATA_COL_WIDTH,
} from "./metricsTableLayout";

export type MetricsTableColgroupProps = {
  dataColumnCount: number;
  /** First N data columns use fixed px width (sticky summary cols). Remainder scroll. */
  fixedLeadingDataColumnCount?: number;
  fixedLeadingDataColWidth?: number;
  scrollDataColWidth?: number;
};

/** Shared column widths: fixed label col; optional fixed leading data cols + scroll cols. */
export const MetricsTableColgroup: React.FC<MetricsTableColgroupProps> = ({
  dataColumnCount,
  fixedLeadingDataColumnCount = 0,
  fixedLeadingDataColWidth = METRICS_TABLE_MIN_DATA_COL_WIDTH,
  scrollDataColWidth,
}) => {
  const scrollWidth = scrollDataColWidth ?? fixedLeadingDataColWidth;
  const leadingCount = Math.min(fixedLeadingDataColumnCount, dataColumnCount);
  const scrollCount = dataColumnCount - leadingCount;

  if (leadingCount === 0) {
    const dataColWidth = getMetricsDataColWidth(dataColumnCount);
    return (
      <colgroup>
        <col style={{ width: METRICS_TABLE_LABEL_COL_WIDTH }} />
        {Array.from({ length: dataColumnCount }, (_, idx) => (
          <col key={idx} style={{ width: dataColWidth }} />
        ))}
      </colgroup>
    );
  }

  return (
    <colgroup>
      <col style={{ width: METRICS_TABLE_LABEL_COL_WIDTH }} />
      {Array.from({ length: leadingCount }, (_, idx) => (
        <col
          key={`leading-${idx}`}
          style={{ width: fixedLeadingDataColWidth }}
        />
      ))}
      {Array.from({ length: scrollCount }, (_, idx) => (
        <col key={`scroll-${idx}`} style={{ width: scrollWidth }} />
      ))}
    </colgroup>
  );
};
